<button class="store-actions-menu-button default-button" mat-raised-button [matMenuTriggerFor]="actionsMenu"
        style="height: 36px; line-height: 30px;" (menuOpened)="loadCollections()">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
    <span>{{ 'STORE_ACTIONS.ACTIONS' | translate }}</span>
    <fa-icon icon="caret-down"></fa-icon>
  </div>
</button>

<mat-menu #actionsMenu="matMenu">
  <button mat-menu-item [matMenuTriggerFor]="collectionsMenu"
          mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
          [analyticsEventParameters]="{'target': 'store-actions-menu-add-to-collection-button'}">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <div class="default-icon-container" fxLayoutAlign="center center">
        <fa-icon icon="folder-plus"></fa-icon>
      </div>
      <span>{{ 'STORE_ACTIONS.ADD_TO_COLLECTION' | translate }}</span>
    </div>
  </button>
  <button mat-menu-item (click)="openDownloadWizard()" [disabled]="!hasStandardLicense"
          mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
          [analyticsEventParameters]="{'target': 'store-actions-menu-download-data-button'}">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <div class="default-icon-container" fxLayoutAlign="center center">
        <fa-icon icon="cloud-download-alt"></fa-icon>
      </div>
      <span>{{ 'STORE_ACTIONS.DOWNLOAD_DATA' | translate }}</span>
    </div>
  </button>
  <button mat-menu-item (click)="copyUrlToClipboard()" *ngIf="storeUuids?.length === 1"
          mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
          [analyticsEventParameters]="{'target': 'store-actions-menu-share-button'}">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <div class="default-icon-container" fxLayoutAlign="center center">
        <fa-icon icon="share-alt"></fa-icon>
      </div>
      <span>{{ 'STORE_ACTIONS.SHARE' | translate }}</span>
    </div>
  </button>
   <button *ngIf="assetReviewDropdown && (hasInternalLicense || hasStandardLicense)"
     mat-menu-item
     (click)="openAssetReview()"
     [disabled]="assetReviewDisabled"
     [style.cursor]="assetReviewDisabled ? 'not-allowed' : 'pointer'"
     [matTooltip]="assetReviewDisabled ? assetReviewTooltip : ''"
     matTooltipPosition="right">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <div class="default-icon-container" fxLayoutAlign="center center">
        <img src="assets/images/file-edit-line.png" alt="Share Icon" [style.opacity]="assetReviewDisabled ? '0.5' : '1'">
      </div>
      <div class="text-container" [style.opacity]="assetReviewDisabled ? '0.5' : '1'">
        <span>{{ 'Asset Review ' | translate }}</span>
        <div>{{ 'Report' | translate }}</div>
      </div>
      <div class="badge--1-0-_168-2768" [style.opacity]="assetReviewDisabled ? '0.5' : '1'">
        <span class="text-new_168-2769">NEW</span>
      </div>
    </div>
  </button>

</mat-menu>

<mat-menu #collectionsMenu="matMenu">
  <button mat-menu-item mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
          [analyticsEventParameters]="{'target': 'store-actions-menu-create-collection-button'}">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" (click)="openCreateNewCollectionWizard()">
      <div class="default-icon-container" fxLayoutAlign="center center">
        <fa-icon icon="plus"></fa-icon>
      </div>
      <span>{{ 'STORE_ACTIONS.NEW_COLLECTION' | translate }}</span>
    </div>
  </button>
  <div>
    <mat-divider></mat-divider>
    <div *ngIf="collections.length; else noFavorites">
      <div class="color-muted" style="padding: 10px;">{{ 'STORE_ACTIONS.FAVORITE_COLLECTIONS' | translate }}</div>
      <div>
        <button mat-menu-item *ngFor="let collection of collections" (click)="addToCollection(collection)"
                mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
                [analyticsEventParameters]="{'target': 'store-actions-menu-add-to-favorite-collection-button'}">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <div class="default-icon-container" fxLayoutAlign="center center">
              <fa-icon icon="folder"></fa-icon>
            </div>
            <div fxLayout="column" style="max-width:200px; line-height: 16px;">
              <small class="text-ellipsis"><strong>{{collection.name}}</strong></small>
              <small class="text-ellipsis color-muted" *ngIf="collection.description">{{collection.description}}</small>
            </div>
          </div>
        </button>
      </div>
    </div>
    <mat-divider></mat-divider>
  </div>
  <button mat-menu-item (click)="openAddToCollectionWizard()" mtnAnalyticsEventTrigger
          [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
          [analyticsEventParameters]="{'target': 'store-actions-menu-add-to-other-collection-button'}">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <div class="default-icon-container" fxLayoutAlign="center center">
        <fa-icon icon="ellipsis-h"></fa-icon>
      </div>
      <span>{{ 'STORE_ACTIONS.OTHER' | translate }}</span>
    </div>
  </button>
</mat-menu>

<ng-template #noFavorites>
  <div class="color-muted" style="padding: 10px;">{{ 'STORE_ACTIONS.NO_FAVORITES_FOUND' | translate }}</div>
</ng-template>
